import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsGlobalViewsRoute: InvariantJiraRoute = {
	name: 'polaris-settings-global-views',
	path: '/jira/settings/products/jira-product-discovery/global-views',
	exact: true,
};
